import type { Vec2 } from '../../../../geo/types';

/**
 * The Jan Roodenpoort as it stood in 1538 (docs/plans/landmarks.md, "Jan Roodenpoort"): a square
 * gate tower on the Singel wall with the round tower of the gate (tower-jan-roodenpoort, site-geo's)
 * against its north flank, the bridge over the Singel leaving its field face. In the layout's frame of
 * the gate (site-geo's record): u along the passage from the city toward the field, v to its left.
 *
 * The painting (scan 4440-4600 x 1610-1800) draws a square tower on the arcaded wall, a slender spire
 * over gables on its faces and the railed bridge at its foot; the woodcut (uva 2380-2700 x 1480-1720)
 * the same tower, its spire rising from four gables with finials and a flag, the round tower on its
 * field side to the north. Plan: the record's 7 x 7 m box. Heights: see HELM (all L).
 */
export const JAN_ROODENPOORT_ID = 'gate-jan-roodenpoort';

export const JAN_ROODENPOORT_FRAME = { origin: [-202.0, 162.8] as Vec2, heading: 2.6291 } as const;

/* Founded, as the other gates, below the moat's water. */
export const JAN_ROODEN_FOOT = -1.2;

/**
 * The gate tower on the record's box. Its eave is level with the round tower's top of 10 m (the
 * record), as the woodcut draws them; the painting's proportion, over the painter's vertical
 * exaggeration of 3.54, puts it about 3.7 m over the 5.5 m wall, near 9.2 m.
 */
export const JAN_ROODEN_TOWER = {
  u: [-3.5, 3.5] as const,
  v: [-3.5, 3.5] as const,
  eave: 10.0,
} as const;

/** As wide as the record's bridge; its arch is not drawn in either source (L). */
export const JAN_ROODEN_PASSAGE = { v: [-1.5, 1.5] as const, springing: 2.4 } as const;

/**
 * A spire over a gable on each face (a Rhenish helm): gable tips 1.5 m over the eave, the spire about
 * 5.5 m over the eave as painted (rows 1703 to 1632, over the same exaggeration), a finial and a vane.
 */
export const HELM = {
  gable: 11.5,
  apex: 15.5,
  finialTop: 16.2,
  finialRadius: 0.07,
  gableFinial: { height: 0.6, radius: 0.04 },
} as const;

/** One row of two arched windows on each face (the woodcut draws two rows, the painting one); L. */
export const JAN_ROODEN_WINDOWS = {
  width: 0.6,
  sill: 6.2,
  head: 7.4,
  across: [-1.8, 1.8],
} as const;
